module.exports = __webpack_public_path__ + "img/facebook-circle.1542e579.svg";